import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes, valueItems } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** Sections 10 + 11 — everything included and the offer box with the price. */
export function LibrarySection() {
  return <section id="offer" aria-labelledby="library-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-143" data-mp="1ahyrcedpbdpw">
      <div className="mx-auto max-w-5xl" data-id="element-144" data-mp="1f9gp6tkfgy6n">
        <SectionHeading id="library-heading" eyebrow="Everything You Get" title={<>
              One Nail Educator Library. <Accent data-id="element-146" data-mp="16gv9xng099mk">Ready When You Need It.</Accent>
            </>} body="Think about how much time it would take to independently create 150 lesson structures, exercises, correction guides, assessments and visual references. You don't need to create all of that before your next class." data-id="element-145" data-mp="11h8z1knng5gx" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(120,96,56,0.55)]" data-id="element-147" data-mp="3ibgwhzqrmbvh">
          <div className="bg-brand-charcoal px-6 py-4 text-center" data-id="element-148" data-mp="3r8r85m7hw30x">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-149" data-mp="3n7xk8su1yo81">
              Complete Nail Educator System
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-150" data-mp="2ujrz44z36x7o">
            <img src={MOCKUP_URL} alt="Everything included in Nail Educator Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[560px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(120, 96, 56, 0.2))'
          }} data-id="element-151" data-mp="2ul2zdutbpmu1" />

            <ul className="mt-10 grid gap-x-8 gap-y-3 sm:grid-cols-2" role="list" data-id="element-152" data-mp="2bsio1r9o40dz">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-brand-charcoal" data-id="element-153" data-mp="eql6wug9fgni">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-154" data-mp="oih5s7q67ass" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-10 border-t border-dashed border-brand-charcoal/20 pt-8 text-center" data-id="element-155" data-mp="3rz7h924iug1v">
              <h3 className="font-display text-[1.7rem] font-bold leading-[1.15] text-brand-charcoal sm:text-[2rem]" data-id="element-156" data-mp="swnzs5r6jl3">
                Build Your Classes Without Building Everything From Scratch.
              </h3>
              <ul className="mx-auto mt-5 flex max-w-xl flex-wrap justify-center gap-2" role="list" data-id="element-157" data-mp="aqssw283kiar">
                {valueItems.map(item => <li key={item} className="rounded-full bg-brand-paper px-3.5 py-1.5 font-body text-[12px] text-brand-charcoal/75" data-id="element-158" data-mp="1h6mpqs9egvrk">
                    {item}
                  </li>)}
              </ul>

              <CtaBlock label="Get Nail Educator Ready™" showPrice className="mt-9" data-id="element-159" data-mp="31q8emq7wi3n0" />
              <p className="mt-4 font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-160" data-mp="2wxp1tvh1fcj9">
                One-Time Payment • No Subscription • Instant Access
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}